import { AfterViewInit, Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { PrettyLineService } from '../services/pretty-line.service';

@Directive({
    selector: '[appRoadDrawer]',
    standalone: true
})
export class RoadDrawerDirective implements  AfterViewInit, OnDestroy {

  constructor(
    private readonly prettyLine: PrettyLineService
  ) { }

  get isParacelsus() {
    return this.prettyLine.isParacelsus;
  }

  ngOnDestroy(): void {
    this.prettyLine.clearLine();
  }

  ngAfterViewInit(): void {
    if (this.isParacelsus) return;
    setTimeout(() => this.prettyLine.reDrawPrettyLine(), 0);
  }
}
